<template>
    <div>
        <FullCalendar :options="calendarOptions"/>

        <CalendarEventsInfoModal
            :input_calendar="calendar && calendar._def.extendedProps"
            :input_title="calendar && calendar.title"
            :input_date="date"
        >
        </CalendarEventsInfoModal>
        <CalendarEventsMapModal
            :input_calendar="calendar && calendar._def.extendedProps"
            :input_title="calendar && calendar.title"
            :input_coordinates="coordinates"
        >
        </CalendarEventsMapModal>
    </div>
</template>

<script>
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import listPlugin from '@fullcalendar/list'
    import interactionPlugin from '@fullcalendar/interaction';
    import bootstrapPlugin from '@fullcalendar/bootstrap';
    import CalendarEventsInfoModal from "./CalendarEventsInfoModal";
    import CalendarEventsMapModal from "./CalendarEventsMapModal";

    export default {
        name: "CalendarEvents",
        props: {
            input_events: Array
        },
        components: {
            FullCalendar,
            CalendarEventsInfoModal,
            CalendarEventsMapModal
        },
        data() {
            return {
                calendarOptions: {
                    plugins: [ dayGridPlugin, interactionPlugin, listPlugin, bootstrapPlugin ],
                    initialView: 'dayGridMonth',
                    themeSystem: 'bootstrap',
                    headerToolbar: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,listMonth'
                    },
                    events: this.input_events,
                    eventClick: (args) => {
                        const { start, end, allDay } = args.event

                        $('#eventModal').modal()

                        this.calendar = args.event;
                        this.coordinates = {
                            lat: parseFloat(this.calendar._def.extendedProps.address_latitude),
                            lng: parseFloat(this.calendar._def.extendedProps.address_longitude)
                        }
                        this.date = { start, end, allDay };
                    }
                },
                calendar: null,
                coordinates: {},
                date: null
            }
        }
    }
</script>

<style lang="less">
    #calendar {
        padding: 1.25rem;
    }

    .fc-header-toolbar {
        margin: 0.625rem 1rem 1.5rem;
    }

    .fc button {
        box-sizing: border-box;
        margin: 0;
        height: 2.6em !important;
        cursor: pointer;
    }
    .fc-prev-button, .fc-next-button {
        min-width: 10rem !important;
    }
    .fc-prev-button {
        margin-right: 1rem !important;
    }

    .fc-event {
        background: #f7c44e;
        border: #f7c44e;
    }
    .fc-today {
        background: #fef1c9;
    }
    .fc-month-button, .fc-listMonth-button {
        padding: 0 1.25rem !important;
    }

    .fc-event-dot {
        background: #f7c44e;
    }
</style>
